import './index.scss';
import React, { useState, useRef } from 'react';
import { scrollTo } from '../../utils';
import ArrowButton from '../ArrowButton';
import HoverSection from './HoverSection';
import { StaticImage } from 'gatsby-plugin-image';

import chess from '../../assets/bannerfull/chess.webp';
import kompetenzen from '../../assets/bannerfull/kompetenzen.webp';
import technologie from '../../assets/bannerfull/technologie.webp';
import balance from '../../assets/bannerfull/balance.webp';

const HoverSections = [
  {
    header: 'Strategie',
    text:
      'Unsere Innsbrucker Webagentur setzt auf Kundenzufriedenheit durch erprobte Abläufe, ein benutzerfreundliches Customer Portal und Ticketsystem. Erfahren Sie mehr über unsere Strategie und Arbeitsweise.',
    link: '/strategie',
    linkText: 'effektiv',
    modifier: 'big',
    image: chess
  },
  {
    header: 'Leistungen',
    text:
      'Von Design und Programmierung bis hin zu E-Commerce und benutzerfreundlichen Schnittstellen - entdecken Sie die vielfältigen Kompetenzen, die innovative Lösungen für anspruchsvolle Anforderungen ermöglichen. Wir verschieben Grenzen und setzen neue Maßstäbe.',
    link: '/leistungen',
    linkText: 'qualitätsbewusst',
    modifier: 'small',
    image: kompetenzen
  },
  {
    header: 'TYPO3',
    text:
      'Wir entwickeln komplexe TYPO3-Websites und sorgen mit regelmäßigen Updates und Sicherheitschecks dafür, dass Ihr System stabil, sicher und zukunftsfähig bleibt.',
    link: '/typo3',
    linkText: 'zuverlässig',
    modifier: 'small',
    image: technologie
  },
  {
    header: 'Projekte',
    text:
      'Entdecken Sie unsere ansprechenden Projekte, die sich durch Nutzerfreundlichkeit und individuelle Anpassung auszeichnen. Erfahren Sie, wie wir maßgeschneiderte Lösungen entwickeln, um die Bedürfnisse unserer Kund:innen optimal zu erfüllen.',
    link: '/projekte',
    linkText: 'maßgeschneidert',
    modifier: 'big',
    image: balance
  }
];

const BannerFull = () => {
  const [activeHeaderItem, setActiveHeaderItem] = useState(0);
  const containerRef = useRef(null);

  const scroll = () => {
    const { bottom } = containerRef.current.getBoundingClientRect();
    scrollTo(window.scrollY + bottom);
  };

  return (
    <div className="banner-full" ref={containerRef}>
      <div className="banner-full__center">
        {HoverSections.map((section, index) => (
          <HoverSection
            {...section}
            isActive={activeHeaderItem === index}
            onMouseEnter={() => setActiveHeaderItem(index)}
            key={index}
          />
        ))}
      </div>
      <div className="banner-full__bottom">
        <ArrowButton mods={['color-white', 'down']} onClick={scroll} ariaLabel='Zum Inhalt scrollen' />
      </div>
    </div>
  );
};

export default BannerFull;
